/**
 * 常量文件，用于多处使用相同变量，便于修改。
 * 如：发送验证码使用的间隔时间
 */
import { getUrlKey } from '@/utils'
const SF_IUOP_OS = 'IUOP_OS' // 马来os
const SF_IUOP_OS_ID = 'IUOP_OSID' // 马来os
const SF_SHOPLINE = 'IUOPATS_SHOPLINE'
const IUOPATS_SHOPIFY = 'IUOPATS_SHOPIFY'
const ICAS = 'IBU-ICAS-CORE'
const SF_IUOP = 'IUOP'
const IUOP_BOSCH = 'IUOP_BOSCH'
const SF_BUY = 'SFBUY'
const GLS = 'GLS'
const ESG_THACSP_CORE_OS = 'ESG-THACSP-CORE-OS'
const IFTP = 'IFTP'
const SDM = 'IBU-SDM-CORE'
const ACS = 'ACS'
const OPENAPI = 'SYS_OPERATE'
const INEX = 'Inex'
const AMAZON = 'AMAZON'
const ISCO = 'ISCO'
const ISCO_OS = 'ISCO-OS'
const ISCOUS = 'SCS-CCS-CORE-US'
const CBS = 'CBS'
const CAIR = 'CAIR-HRFA-MANUAL'
const IBU_EPES_CORE_OS = 'IBU-EPES-CORE-OS' // SF Korea ERP系统
const TERM_USER = 20 // 用户协议的type值
const EPES_ACCEPTABLE_USE = 124 // SF Korea ERP可接受使用政策的type值
const STEP_TIME = 60 // 发送短信验证码时间间隔
const MAIL_REGEXP = /^\w+((-\w*)|(\.\w+)|(\+\w*))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/ // 邮箱正则 v1.1
const REMEMBER_TIME = 15
const REMEMBER_T = 1000 * 60 * 60 * 24 * REMEMBER_TIME
const ENRYPT_KEY = 'r5nB7xnpAR4rpObxOp65zw5OabNQozAH'
const ERROR_TEL_REG = '^[0-9]{3,20}$' // 手机号正则
const USER_NAME_REG = /^[a-zA-Z]\w{5,19}$/i // 用户名正则
const TIME_STAMPS = Date.parse(new Date()) / 1000 // 时间戳
const SPECIAL_KEY = "[ _`~!@#$%^&*()+=|{}':;',\\[\\].<>/?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？]|\n|\r|\t|[0-9]" // 特殊字符校验和数字
// const SPECIAL_CHARACTER_REGEXP = "[\\.。,、;:\\?\\!ˉˇ¨`~々~‖∶\"'`|·…—~-〃@#＊？！；‥˙、&‘’“”〝〞〔〕〈〉《》「」『』〖〗" +
// '【】()\\[\\]\\{\\}\\+\\-×÷﹢﹣±/=∥∠≌∽≦≧≒﹤﹥≈≡≠=≤≥<>≮≯∷∶∫∮∝∞∧∨∑∏∪∩∈∵∴⊥∥∠⌒⊙√∟⊿㏒㏑%‰℃℉°′″\\$￡￥￠♂♀℅' +
// '①②③④⑤⑥⑦⑧⑨⑩㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩№⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛' +
// 'ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ]'
const CURRENT_ROUTE_NAME = 'OrderEdit'
// 单票下单收寄件类型欧洲28国
const COUNTRY_ORDER = ['GB', 'IE', 'NL', 'MT', 'DE', 'FR', 'ES', 'IT', 'BE', 'AT', 'HU', 'PT', 'DK', 'CZ', 'HR', 'GR', 'BG', 'LU', 'SI', 'SK', 'RO', 'CY', 'SE', 'FI', 'LT', 'LV', 'PL', 'EE', 'CA', 'KR', 'CN', 'TW']
// 最多12位整数，两位小数（输入金额的正则）
const REG_MONEY = /^(([1-9]{1}\d{0,11})|(0{1}))(\.\d{0,2})?$/
// 最多20位数字（月结卡号的正则）
const REG_MONTHYL_CARD = /^[0-9]{0,20}$/
// 单票下单：产品快件代码为为其他之一，隐藏税金付款方式
const PRODUCT_CODE = ['C93801', 'C93802', 'C93803', 'C93804']
const MSG_URL = ['/sso/whitelist', '/auth/drainageLogin']
const SERVICE_OBJ = {
  'CN': 'SFYUN',
  'SG': 'GCP',
  'OS': 'GCP'
}
const mapLogos = {
  'TH': require('@/assets/common/ic_kex_cobrand.svg'),
  'US': require('@/assets/common/ic_kex_cobrand.svg'),
  'CA': require('@/assets/common/ic_kex_cobrand.svg'),
  'IN': require('@/assets/common/ic_kex_cobrand.svg'),
  'BD': require('@/assets/common/ic_kex_cobrand.svg'),
}
const isIUOPOS = () => {
  return getUrlKey('sysCode') === SF_IUOP_OS
}

const isOS = () => {
  return window._global.CURRENT_SITE === 'OS'
}

const isMy = () => {
  return isOS() && !isTh() && !isId() && !isVn()
}
const isUS = () => {
  return window._global.CURRENT_SITE === 'US'
}
const isTh = () => {
  return window._global.CURRENT_SITE_COUNTRY === 'TH'
}

const isId = () => {
  return window._global.CURRENT_SITE_COUNTRY === 'ID'
}

const isVn = () => {
  return window._global.CURRENT_SITE_COUNTRY === 'VN'
}

const PING_AN = 'PING_AN'
const ZI_RU = 'IUOP_ZIRU'

const SystemCodeUseNewConfigApi = [SF_IUOP, PING_AN, ZI_RU, IUOP_BOSCH, CAIR]

const registerCountry = {
  US: ['US'],
}

const unuseRegisterCountry = {
  CN: ['US', 'TW'],
  SG: ['US', 'CN']
}

const unuseLoginAreaCode = {
  CN: ['US', 'TW'],
  SG: ['US']
}

export {
  isOS,
  isIUOPOS,
  mapLogos,
  SF_SHOPLINE,
  IUOPATS_SHOPIFY,
  ICAS,
  SF_IUOP_OS,
  CBS,
  SDM,
  SF_IUOP,
  SF_BUY,
  GLS,
  ACS,
  INEX,
  ESG_THACSP_CORE_OS,
  AMAZON,
  ISCO,
  ISCO_OS,
  IBU_EPES_CORE_OS,
  IFTP,
  TERM_USER,
  EPES_ACCEPTABLE_USE,
  STEP_TIME,
  MAIL_REGEXP,
  OPENAPI,
  REMEMBER_TIME,
  REMEMBER_T,
  ENRYPT_KEY,
  ERROR_TEL_REG,
  USER_NAME_REG,
  TIME_STAMPS,
  SPECIAL_KEY,
  // SPECIAL_CHARACTER_REGEXP,
  CURRENT_ROUTE_NAME,
  COUNTRY_ORDER,
  REG_MONEY,
  REG_MONTHYL_CARD,
  PRODUCT_CODE,
  MSG_URL,
  SERVICE_OBJ,
  isTh,
  SystemCodeUseNewConfigApi,
  registerCountry,
  unuseRegisterCountry,
  unuseLoginAreaCode,
  isUS,
  IUOP_BOSCH,
  CAIR,
  ISCOUS,
  isId,
  SF_IUOP_OS_ID,
  isVn,
  isMy
}
